module.exports = __webpack_public_path__ + "static/media/b14.91ac3e71.webp";